<div [ngClass]="state=='open' ? 'main_content_open' : 'main_content'">

    <p-scrollPanel [style]="{width:'100%',height:'95vh','margin-top':'7px','padding-bottom':'70px'}">

        <div class="p-d-flex p-jc-between p-ai-center p-pt-3 p-pb-3">

            <div class="page_title">
                Privacy Policy
            </div>

            <div>
                <p-breadcrumb [model]="items" [home]="home"></p-breadcrumb>
            </div>

        </div>

        <p-card>

            <!-- ADD BUTTON -->
            <div class="p-d-flex p-jc-end p-mb-3">
                <button pButton label="Add Document" icon="pi pi-plus" class="p-button-success"
                    (click)="openUploadDialog()">
                </button>
            </div>


            <!-- DOCUMENT TABLE -->

            <p-table [value]="documentsList">

                <ng-template pTemplate="header">
                    <tr>
                        <th>Document Name</th>
                        <th>Uploaded Date</th>
                        <th style="width:200px">Action</th>
                    </tr>
                </ng-template>

                <ng-template pTemplate="body" let-doc>
                    <tr>

                        <td>{{doc.fileName}}</td>

                        <td>{{doc.uploadedAt ? (doc.uploadedAt | date:'dd MMM yyyy') : '-'}}</td>

                        <td>

                            <a href="javascript:void(0);" (click)="preview(doc.type)" class="p-mr-3">
                                <i class="pi pi-eye" style="font-size:0.9rem;color:#2196F3;"></i>
                            </a>

                            <a href="javascript:void(0);" (click)="confirmDeleteDialog(doc.type)">
                                <i class="pi pi-trash" style="font-size:0.9rem;color:#dc3545;"></i>
                            </a>

                        </td>

                    </tr>
                </ng-template>


                <!-- EMPTY / LOADING TEMPLATE -->
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="3">

                            <div *ngIf="isLoading" class="alignCenter">
                                <p-progressSpinner [style]="{ width: '40px', height: '40px' }" strokeWidth="3">
                                </p-progressSpinner>
                            </div>

                            <p-messages *ngIf="documentsList?.length == 0 && !isLoading" key="errMsg"
                                class="alignCenter">

                                <ng-template pTemplate>
                                    <i class="pi pi-copy" style="font-size:2rem"></i>
                                    <div class="p-ml-2">NO DATA FOUND</div>
                                </ng-template>

                            </p-messages>

                        </td>
                    </tr>
                </ng-template>

            </p-table>


            <!-- PDF PREVIEW -->

            <div *ngIf="previewUrl" class="p-mt-4">

                <h3>Document Preview</h3>

                <div style="height:600px;overflow:auto;border:1px solid #ddd">

                    <iframe [src]="previewUrl" width="100%" height="100%" style="border:none">
                    </iframe>

                </div>

            </div>

        </p-card>

    </p-scrollPanel>


    <p-dialog #uploadDialog header="Upload Document" [(visible)]="displayUploadDialog" [modal]="true"
        [baseZIndex]="10000" [style]="{'width': dialogWidth}" [draggable]="false" [resizable]="true"
        [maximizable]="true" (onHide)="clearFormData()" (onShow)="showDialogMaximized($event, uploadDialog)">

        <form>

            <div class="form-group">
                <label>Select PDF File</label>

                <input #fileInput type="file" class="form-control" accept="application/pdf"
                    (change)="selectFile($event)">
            </div>

        </form>

        <ng-template pTemplate="footer">

            <button pButton label="Cancel" icon="pi pi-times" class="p-button-text p-button-danger"
                (click)="displayUploadDialog=false">
            </button>

            <button pButton label="Upload" icon="pi pi-upload" (click)="upload()" [disabled]="!selectedFile">
            </button>

        </ng-template>

    </p-dialog>

</div>

<!-- REMOVE USER MODAL -->
<p-confirmDialog [baseZIndex]="10000" rejectButtonStyleClass="p-button-text" [style]="{width:'45vw'}">
</p-confirmDialog>